<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="process"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import CodeServices from '@/services/api/code.api'
import locationApi from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  name: 'Findings',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Hallazgos',
      routes: ['Informes', 'Informe de Hallazgos'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          regions: [],
          disciplineTypeServices: [],
        },
        filters: {
          academicYear: null,
          region: null,
          disciplineTypeService: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Fiscal',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Región',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-3',
          options: this.model.search.collections.regions,
          value: this.model.search.filters.region,
          disabled: this.model.search.collections.regions.length <= 0,
        },
        {
          name: 'disciplineTypeService',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Servicio',
          placeholder: 'Seleccionar',
          clearable: true,
          class: 'col-md-3',
          options: this.model.search.collections.disciplineTypeServices,
          value: this.model.search.filters.disciplineTypeService,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          type: 'text',
          label: 'SIE',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          class: 'col-md-3',
          leftIcon: true,
          value: this.model.search.filters.sie,
          disabled: this.model.search.filters.sieDisabled,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        ({ data }) => (this.model.search.collections.academicYears = data)
      )
      await CodeServices.getDisciplineTypeServices().then(
        ({ data }) =>
          (this.model.search.collections.disciplineTypeServices = data)
      )
    },
    async onChangeAcademicYear() {
      this.model.search.filters.region = null
      this.model.search.collections.regions = []

      await this.getRegion()
    },
    async getRegion() {
      await locationApi
        .getRegions({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then(({ data }) => (this.model.search.collections.regions = data))
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (isValid) {
        await ReportServices.getReport('errorlogreport', {
          academicYearId: this.model.search.filters.academicYear?.id,
          regionId: this.model.search.filters.region?.id,
          serviceId: this.model.search.filters.disciplineTypeService?.id,
          sie: this.model.search.filters.sie,
        }).then(({ data }) => DocumentServices.Download(data))
      }
    },
  },
}
</script>
